import { Path } from 'slate';
import { assertNonNull } from '../utils';

export function end(path: Path): number {
    const end = path[path.length - 1];
    assertNonNull(end, 'Path has no end index');
    return end;
}
